<script>
    import router from "page";
    import { onMount } from "svelte";

    import Tabulator from "tabulator-tables";
    import "tabulator-tables/dist/css/tabulator.min.css";

    import { fetchGet } from "../utils/utilsFetch.js";

    import { addToCartFormatter } from "../utils/utilsTabulator.js";

    import {
        productPictureLinkFormatter,
        numberFormatter,
        oneDecimalFormatter,
        percentFormatter,
        keywordFilter,
        dateFormatterSimple,
        numberFormatterSimple,
        openProductModal,
    } from "../utils/utilsTabulator.js";

    import { isLoading, client, locale } from "../stores.js";

    export let invoiceKey;

    let data, tableElement, table;

    onMount(async () => {
        $isLoading = true;

        data = await fetchGet(`/api/invoices/${invoiceKey}`);

        table = new Tabulator(tableElement, {
            height: "100%",
            data: data.invoiceItems,
            layout: "fitDataFill",
            cellVertAlign: "middle",
            columnCalcs: "both",
            columns: [
                {
                    title: "",
                    field: "sku",
                    formatter: productPictureLinkFormatter,
                },
                {
                    title: $locale.sku || "",
                    field: "sku",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                    formatter: (cell, formatterParams, onRendered) => {
                        cell.getElement().style.fontWeight = "bold";
                        return cell.getValue();
                    },
                    cellClick: openProductModal,
                },
                {
                    title: $locale.product || "",
                    field: "productName",
                    width: 300,
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                    formatter: (cell, formatterParams, onRendered) => {
                        cell.getElement().style.fontWeight = "bold";
                        return cell.getValue();
                    },
                    cellClick: openProductModal,
                },
                {
                    title: $locale.vat || "",
                    field: "vat",
                    formatter: percentFormatter,
                },
                {
                    title: $locale.qty || "",
                    field: "qty",
                    formatter: numberFormatter,
                },
                {
                    title: $locale.price || "",
                    columns: [
                        {
                            title: $locale.withVat || "",
                            field: "originalPriceWithVat",
                            formatter: oneDecimalFormatter,
                        },
                        {
                            title: $locale.withoutVat || "",
                            field: "originalPriceWithoutVat",
                            formatter: oneDecimalFormatter,
                        },
                    ],
                },
                {
                    title: $locale.price || "",
                    columns: [
                        {
                            title: $locale.discount || "",
                            field: "rebate",
                            formatter: percentFormatter,
                        },
                        {
                            title: $locale.withoutVat || "",
                            field: "clientPriceWithoutVat",
                            formatter: oneDecimalFormatter,
                        },
                        {
                            title: $locale.withVat || "",
                            field: "clientPriceWithVat",
                            formatter: oneDecimalFormatter,
                        },
                    ],
                },
                {
                    title: $locale.total || "",
                    columns: [
                        {
                            title: $locale.withoutVat || "",
                            field: "totalWithoutVat",
                            formatter: numberFormatter,
                            topCalc: "sum",
                            topCalcFormatter: numberFormatter,
                        },
                        {
                            title: $locale.withVat || "",
                            field: "totalWithVat",
                            formatter: numberFormatter,
                            topCalc: "sum",
                            topCalcFormatter: numberFormatter,
                        },
                    ],
                },
                {
                    title: $locale.stock || "",
                    field: "stockHidden",
                    formatter: (cell) => {
                        let stock = cell.getValue().split(".")[0];

                        if (stock == ($locale.noStock || "Нема")) {
                            cell.getElement().style.color = "red";
                        }

                        return stock;
                    },
                },
                {
                    title: $locale.packaging || "",
                    field: "packaging",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: $locale.order || "",
                    frozen: true,
                    formatter: addToCartFormatter,
                },
            ],
        });

        if ($client.isHiddenPrices) {
            table.hideColumn("vat");
            table.hideColumn("originalPriceWithVat");
            table.hideColumn("originalPriceWithoutVat");
            table.hideColumn("rebate");
            table.hideColumn("clientPriceWithoutVat");
            table.hideColumn("clientPriceWithVat");
            table.hideColumn("totalWithoutVat");
            table.hideColumn("totalWithVat");
        }

        $isLoading = false;
    });
</script>

<div class="container">
    {#if data}
        <div class="header">
            <div><b>{$locale.invoice || ""}:</b> {invoiceKey}</div>
            <div><b>{$locale.date || ""}:</b> {dateFormatterSimple(data.invoice.date)}</div>
            <div>
                <b>{$locale.total || ""}:</b>
                {numberFormatterSimple(data.invoice.totalWithVat)}
            </div>
            <div>
                <b>{$locale.vat || ""}:</b>
                {numberFormatterSimple(data.invoice.totalVat)}
            </div>
            <div><b>{$locale.status || ""}:</b> {data.invoice.status}</div>
        </div>
    {/if}

    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        grid-template-rows: auto 1fr;
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /* background: #ccc; */
        padding: 10px;
    }

    .header div {
        margin-right: 20px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }
</style>
